export default __webpack_public_path__ + "static/media/dont_quit_mobile_1.ec8e5de3.png";